import VueFormGenerator from 'vue-form-generator';
import Vue from 'vue';

export default {

  name: 'form-builder-block',

  inject: [
    'pageBuilderData',
    'providedFormData'
  ],

  props: {
    block: {}
  },

  data () {
    return {
      debugForm: false,
      isValid: false,
      schema: {},
      formData: {},
      formOptions: {
        validateAfterChanged: true
      }
    };
  },

  methods: {
    onValidated (isValid, errors) {
      this.isValid = isValid;
      if (!isValid) {
        Vue.set(this.pageBuilderData, 'allFormsValid', false);
      }
    },
    prettyJSON: function (json) {
      if (json) {
        json = JSON.stringify(json, undefined, 4);
        json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
          let cls = 'number';
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'key';
            } else {
              cls = 'string';
            }
          } else if (/true|false/.test(match)) {
            cls = 'boolean';
          } else if (/null/.test(match)) {
            cls = 'null';
          }
          return '<span class="' + cls + '">' + match + '</span>';
        });
      }
    },
    validateForm: function () {
      if (this.$refs !== undefined) {
        if (this.$refs.hasOwnProperty('toValidateForms')) {
          if (this.$refs.toValidateForms !== undefined) {
            this.$refs.toValidateForms.validate();
          }
        }
      }
    }
  },

  created () {
    this.$eventBus.$on('validateAllPageBuilderForms', this.validateForm);
  },

  mounted () {
    let formRowsWithValidator = [];

    this.block.data.formRows.forEach(function (formRowBase) {
      let formRow = {};
      Object.assign(formRow, formRowBase);
      formRow.id = Math.random().toString(36).substr(2, 9) + formRow.id;

      if (formRow.required) {
        if (formRow.inputType === 'Checkbox') {
          formRow.validator = function (value) {
            if (value !== true) {
              return this.$options.filters.trans('Bitte stimmen Sie zu.');
            }
          };
        } else {
          formRow.validator = VueFormGenerator.validators.string.locale({
            fieldIsRequired: 'Bitte füllen Sie dieses Pflichtfeld.'
          });
        }
      }
      formRowsWithValidator.push(formRow);
    });

    this.schema = {
      styleClasses: '',
      fields: formRowsWithValidator
    };
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/formBuilderBlock/FormBuilderBlock.js